import { DateTime } from 'luxon';
import * as models from 'smg/admin/models';

// Hyejoo's SQL agg explicitly leaves the orders array unordered, so pick by
// max(created) instead of trusting array index.
function mostRecentOrder(orders: models.Order[]): models.Order | undefined {
    let latest: models.Order | undefined;
    for (const o of orders) {
        if (!o.created.isValid) {
            continue;
        }
        if (!latest || o.created > latest.created) {
            latest = o;
        }
    }
    return latest;
}

// Renders the "Used N times · last <MMM DD, YYYY>" line into $meta, with the
// last-used date as an external link to the most recent order. Used by the
// shipping-options and tax-exemption card scrollers — same shape, same
// strings, same Bootstrap classes.
export function RenderUsageMeta($meta: HTMLElement, orders: models.Order[]) {
    const count = orders.length;
    let useLabel: string;
    if (count === 0) {
        useLabel = 'Not yet used';
    } else if (count === 1) {
        useLabel = 'Used once';
    } else {
        useLabel = `Used ${count} times`;
    }
    $meta.replaceChildren(document.createTextNode(useLabel));

    const recent = mostRecentOrder(orders);
    if (!recent?.created.isValid) {
        return;
    }
    $meta.appendChild(document.createTextNode(' · last '));
    const $link = document.createElement('a');
    $link.href = recent.iapURL();
    $link.target = '_blank';
    $link.rel = 'noopener';
    $link.className = 'text-reset text-decoration-underline';
    $link.title = recent.invoiceNumber ? `Order #${recent.invoiceNumber}` : 'Open order';
    $link.textContent = recent.created.toLocaleString(DateTime.DATE_MED);
    const $icon = document.createElement('i');
    $icon.className = 'fas fa-external-link-alt ms-1';
    $link.appendChild($icon);
    // Link clicks shouldn't bubble up and select the parent card.
    $link.addEventListener('click', e => e.stopPropagation());
    $meta.appendChild($link);
}
